import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { LayersControl, Map as LeafletMap, TileLayer, Polygon } from 'react-leaflet'
import { BerthsLayer } from '@teqplay/web-sdk/map'
import { debounce } from 'lodash'

import { BASE_URL, MAP_URL } from '../../../../../../js/constants'
import 'leaflet/dist/leaflet.css'
import './BerthPicker.scss'

export default class BerthPicker extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      zoom: 16,
      mapBounds: null,
      selectedBerth: this.props.selectedBerth || null,
      selectedBerthLatLngs: this.props.selectedBerthLatLngs || null,
      selectedBerthName: null
    }

    this.mapRef = null
    this.setMapRef = element => {
      this.mapRef = element
    }
  }

  static propTypes = {
    terminalCenter: PropTypes.array.isRequired,
    selectedBerth: PropTypes.string,
    selectedBerthLatLngs: PropTypes.array,
    onSelectBerth: PropTypes.func.isRequired,
    token: PropTypes.string.isRequired,
    customFetch: PropTypes.func.isRequired
  }

  componentDidMount() {
    this.mapApi = this.mapRef.leafletElement

    this.setState({
      mapBounds: this.mapApi.getBounds(),
      zoom: this.mapApi.getZoom()
    })
  }

  render() {
    const textForSelectedBerth = (
      <>
        Selected berth: <strong>{this.props.selectedBerth}</strong>
      </>
    )
    const textForNoSelectedBerth = 'Please select a berth'
    return (
      <div className="berth-picker-modal">
        <p>{this.props.selectedBerth ? textForSelectedBerth : textForNoSelectedBerth}</p>
        <div className="berth-picker-container">
          <LeafletMap
            ref={this.setMapRef}
            center={this.props.terminalCenter}
            zoom={this.state.zoom}
            onMoveend={this.handleMoveend}
            onZoomend={this.handleMoveend}
            removeLayerControl={true}
          >
            <LayersControl>
              <BerthsLayer
                name="Berths"
                checked={true}
                bounds={this.state.mapBounds}
                url={BASE_URL + '/v1'}
                handleFetchError={error => console.error(error)}
                onClick={this.handleSelectBerth}
                token={this.props.token}
                customFetch={this.props.customFetch}
              />
            </LayersControl>
            {this.state.selectedBerthLatLngs && (
              <Polygon
                positions={this.state.selectedBerthLatLngs}
                color="#ffc800"
                fillColor="#ffc800"
                fillOpacity={0.5}
                weight={1}
              />
            )}
            <TileLayer url={MAP_URL} tileSize={512} zoomOffset={-1} />
          </LeafletMap>
        </div>
      </div>
    )
  }

  /**
   * Set map boundaries and zoom after the map has been moved
   */
  handleMoveend = debounce(
    () => {
      this.setState({
        mapBounds: this.mapApi.getBounds(),
        zoom: this.mapApi.getZoom()
      })
    },
    500,
    {
      leading: true,
      trailing: false
    }
  )

  handleSelectBerth = berth => {
    const ownerId = berth.ownerId
    const berthName = berth.berthNameLong

    this.setState({ selectedBerthName: berthName })

    // When ownerId exist, show highlighted berth (can be selected)
    if (ownerId) {
      const coordsRoot = berth?.area?.coordinates?.[0] || []
      const latLngs = coordsRoot.map(coord => [coord[1], coord[0]])

      this.setState({ selectedBerthId: ownerId, selectedBerthLatLngs: latLngs })
    }
    this.props.onSelectBerth(ownerId, berth)
  }
}
